import { render, staticRenderFns } from "./ColunaPersonalizada.vue?vue&type=template&id=375ab63e&scoped=true"
import script from "./ColunaPersonalizada.vue?vue&type=script&lang=js"
export * from "./ColunaPersonalizada.vue?vue&type=script&lang=js"
import style0 from "./ColunaPersonalizada.vue?vue&type=style&index=0&id=375ab63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375ab63e",
  null
  
)

export default component.exports